/**
 * 
 * Gestion Javascript des formulaires ACF construit avec des "ACF kinougarde"
 * - Gestion automatique par étapes
 */

import "../internals/form"; // Validateur parsley

(function(w) {
    w.Kinougarde = Object.assign({},w.Kinougarde, { formulaireAcf : {}});

    /**
     * Initialisation du formulaire
     * La formulaire prend un objet option en paramètre
     * {defaultValue : mesvaleurs , defaultStep : etapedeDebut , scrollTop : true }
     */
    w.Kinougarde.formulaireAcf.InitFormulaire = function(paramOptions) {
        
        //
        var defautOption = { defaultValue : null , defaultStep : 0 , scrollTop : true};
        var options = Object.assign(defautOption,paramOptions);

        // Active le carousel
        $(".owl-carousel").owlCarousel({                    
            nav            : false,  
            navContainer : $("#truc-qui-n-existe-pas"), // Bug owl carousel, active l'étape 2 puis la 1 si rien n'est definit ou si navContainer=false
            items : 1,
            URLhashListener:false,
            startPosition : options.defaultStep,
            mouseDrag : false,
            touchDrag:false,
            pullDrag:false, 
            dots: false,
            navText : '',                               
            stagePadding: 120,            
            checkVisible : false,
            responsive : {
                0 : {             
                    mouseDrag : false,
                    toucheDrag:false,
                    pullDrag:false,      
                    margin      : -20,
                    stagePadding: 20
                },
                740 : {                  
                    margin      : 70,
                    stagePadding: 120
                }
            },
            onTranslated : function (e) {
                // Scroll en haut de l'étape suivante ou précédente     
                if (options.scrollTop===true)  {        
                    try {
                        var scrollto = Math.max(jQuery(".acf-steps")[0].offsetTop - jQuery("#header")[0].clientHeight-30,0); // Position de l'étape - hauteur du header - 30px de marge
                        $('html').animate({scrollTop: scrollto}, 200);
                    }
                    catch(e) {}
                }
            },          
        });

        //Actualise la progress bar dans le cas ou l'étape par défaut!=0
        Kinougarde.formulaireAcf.UpdateProgressBar();


        // console.debug("pushState activeIndex= " + etapePardefaut);
        // history.pushState({activeIndex : etapePardefaut},"");

        // Positionne un attribut data-parsley-group sur chaque input de chaque étape        
        $(".step-form.item").each(function(index,step) {
            $(step).find(':input').attr('data-parsley-group', 'step-' + index);
        });
            
        /**
         * Clic sur le bouton suivant
         */
        $(document.body).on('click','.acf-steps .js-trigger-next', function(ev){            
            ev.preventDefault();  
            w.Kinougarde.formulaireAcf.NextStep();
        });
        /**
         * Clic sur le bouton precédent
         */
        $(document.body).on('click','.acf-steps .js-owl-back', function(ev){
            ev.preventDefault();
            w.Kinougarde.formulaireAcf.PrevStep();                   
        });

        
        /**
         * Clic sur un choix multiple
         */
        $(document.body).on('acf-field-type-choix-click','.tap-bloc.auto-next', function(ev){
            ev.preventDefault();
            w.Kinougarde.formulaireAcf.NextStep();                   
        });

        /**
         * Gestion des valeurs par défaut
         */
        if (options.defaultValue!==null) {
            // Pour les input
            $(".acf-steps .item input").each(function() {
                try {
                var name = this.name;
                if (typeof(options.defaultValue[name])!=='undefined' && options.defaultValue[name]!==null) {
                    // si il y a une valeur on affecte la valeur à l'input ayant le même name                    
                    if (this.type=="radio" && this.value==options.defaultValue[name]) {
                        // Pour un radio , on checked la bonne valeur
                        $(this).prop('checked',true);
                    } 
                    else if (this.type=="radio") {
                        // rien                        
                    }
                    // Pour les cases à cocher
                    else if (this.type=="checkbox" && (options.defaultValue[name]===this.value || options.defaultValue[name].includes(this.value))) {
                        $(this).prop('checked',true);
                    }
                    else if (this.type=="checkbox") {
                        // rien
                    }
                    else {
                        // Pour un autre type de champ on affecte la valeur                        
                        $(this).val(options.defaultValue[name]);                        
                        $(this).addClass("input-custom-value");
                    }
                }
                }
                catch(e) {
                    console.info("donnée d'init non prise en compte");
                }
            });
            // POur les textarea
            $(".acf-steps .item textarea").each(function() {
                    try {
                        var name = this.name;
                        if (typeof(options.defaultValue[name])!=='undefined' && options.defaultValue[name]!==null) {
                            $(this).text(options.defaultValue[name]);
                        }
                    }
                    catch (e) {
                        console.info("donnée d'init non prise en compte");
                    }
            });
            // Mise à jour des icons croix et geoloc des google autocomplete
            $(".acf-steps .google-autocomplete").each(function() { 
                try {
                    this.toggleIconGeoloc()
                }
                catch (e) {}
            });

            
        }

        // Tracking Tagmanager
        w.Kinougarde.TagManagerTunnel();
    }    
    
    /**
     * Retourne l'index de l'étape courante
     */
    w.Kinougarde.formulaireAcf.CurrentIndex = function() {
        return $(".owl-carousel .owl-item").index($(".owl-carousel .owl-item").filter('.active'));
    }

    /**
     * Retourne l'étape courante
     */
    w.Kinougarde.formulaireAcf.CurrentStep = function() {
       return $(".owl-carousel .owl-item").filter('.active').find(".step-form.item");
    }

    /**
     * Passe à l'étape suivante
     * @parametre tableau {'action': monActionAjax , 'stepIndex' : indexProchaineEtape, 'data': object }
     * @action Ajax Action
     * @stepIndex Index de la prochaine étape
     * @data objet {'param1',value1,'param2',value2} fusionneé avec les input du form
     *  
     */
     w.Kinougarde.formulaireAcf.NextStep = function(options) {       
        var $form =  $('.acf-steps form');
        var  $step = this.CurrentStep();   
        // Option par défaut
        var defaultOptions = Object.assign(
                {'action': $step.data("ajax-action"),
                 'stepIndex': Kinougarde.formulaireAcf.CurrentIndex()+1,
                 'data' : null},options);                 
        
        //Notifie le changement d'étape 
        // et récupère un éventuel changement sur les options le NextStep               
        defaultOptions = $step.triggerHandler('form-step-next-change',[defaultOptions]) || defaultOptions;     
                                                       
        $form.parsley().validate({group: 'step-' + Kinougarde.formulaireAcf.CurrentIndex()});
        if ($form.parsley().isValid({group: 'step-' + Kinougarde.formulaireAcf.CurrentIndex()})) {   
            
            
            // Action ajax                
            if (typeof(defaultOptions.action)!=='undefined') {
                //Action ajax entre  deux étapes                
                $step.addClass('loading-state');  
                var data = {};
                // Recupère toutes les valeurs des champs du formualire pour les stocker dans un javascript
                $form.serializeArray().forEach(function(value, key){                                               
                        if (data[value['name']]) {
                            if (!data[value['name']].push) {
                                data[value['name']] = [data[value['name']]];
                            }
                            data[value['name']].push(value['value'] || null);
                        } else {
                            data[value['name']] = value['value'] || null;
                        }
                });          
                data = Object.assign(data, defaultOptions.data, {'action': defaultOptions.action});
                data = Object.assign(data,Kinougarde.GetGlobalUtmFields());
                // Appel ajax
                $.ajax({
                    type     : 'POST',
                    dataType : 'json',
                    url      : ajax_kinougarde_object.ajaxurl,
                    data     : data,
                    success  : function (reponse) {                        
                        var continueStep = $step.triggerHandler('form-step-next-ajax-success',[reponse,data]);     
                        $step.removeClass('loading-state');
                        if (continueStep!==false && reponse.success===true) {
                            // Supprime les erreurs précédentes
                            $("div.ajax-error").remove();
                            // On Passe à l'étape suivante
                            // console.debug("pushState activeIndex= " + defaultOptions.stepIndex);
                            // history.pushState({activeIndex : defaultOptions.stepIndex},"");
                            var owl = $('.owl-carousel');                        
                            owl.owlCarousel().trigger('to.owl.carousel',[defaultOptions.stepIndex,200]);
                            // Modif de la progresse barre                        
                            //var indexProgressBar = parseInt($('.acf-steps .progress-bar').attr("data-step"));
                            Kinougarde.formulaireAcf.UpdateProgressBar();                                            
                            
                            // Propage un évènement ajax-action-success
                            $step.trigger("form-step-next-changed",[reponse,data]);
                            // Notification Tagmanager                
                            // kinougarde_tracking({
                            //     "event" : "VirtualPageview",
                            //     "virtualPageURL" : window.location.pathname + "step-" + (defaultOptions.stepIndex) + "/",
                            //     "virtualPageTitle" : document.title + " - STEP " + (defaultOptions.stepIndex)
                            // });
                            Kinougarde.TagManagerTunnel();
                        } else if (reponse.success===false) {
                            // Code 200 , mais erreur métier, on affiche le message                            
                            if (typeof(reponse.data.error_msg)!=='undefined') {
                                Kinougarde.formulaireAcf.AfficherErrorAjax(reponse.data.error_msg);                            
                            } else {
                                Kinougarde.formulaireAcf.AfficherErrorAjax("Désolé, une erreur a été détectée, veuillez réessayer plus tard");                            
                            }
                            // Propage un évènement ajax-action-error 
                            $step.trigger("ajax-action-error",[reponse]);
                        }

                    },                    
                    error: function (reponse) {
                        // Affichage d'un message d'erreur                             
                        $step.removeClass('loading-state');
                        if (reponse.responseJSON && reponse.responseJSON.data && reponse.responseJSON.data.error_msg) {
                            Kinougarde.formulaireAcf.AfficherErrorAjax(reponse.responseJSON.data.error_msg);                            
                        } else {
                            Kinougarde.formulaireAcf.AfficherErrorAjax("Désolé, une erreur a été détectée, veuillez réessayer plus tard");                            
                        }

                        // Propage un évènement ajax-action-error 
                        $step.trigger("ajax-action-error",[reponse]);
                    }
                });               
            } else {
                // Pas d'action ajax entre les deux étapes                
                // On Passe à l'étape suivante
                var owl = $('.owl-carousel');
                // Modif de la progresse barre                                
                // console.debug("pushState activeIndex= " + defaultOptions.stepIndex);
                // history.pushState({activeIndex : defaultOptions.stepIndex},"");
                owl.owlCarousel().trigger('to.owl.carousel',[defaultOptions.stepIndex,200]);
                //var indexProgressBar = parseInt($('.acf-steps .progress-bar').attr("data-step"));
                this.UpdateProgressBar(); 
                
                
                $step.trigger("form-step-next-changed");
                // Notification Tagmanager
                // kinougarde_tracking({
                //     "event" : "VirtualPageview",
                //     "virtualPageURL" : window.location.pathname + "step-" + (defaultOptions.stepIndex) + "/",
                //     "virtualPageTitle" : document.title + " - STEP " + (defaultOptions.stepIndex)
                // });
                Kinougarde.TagManagerTunnel();                      
            }                

        }
        
     }


     /**
      * Met à jour la progressbar
      */
     w.Kinougarde.formulaireAcf.UpdateProgressBar = function() {
         // Le stepnumber peut être différent de l'index des etapes du fait d'étape n'affichant pas la barre de progression
         try {
         var $step = this.CurrentStep();  
         if (typeof($step.data("progress-index"))!=='undefined' && $step.data("progress-index")!==null) { 
             // Utilise la surcharge paramétrée sur l'étape
             $('.acf-steps .progress-bar').attr("data-step",$step.data("progress-index"));             
         } 
         // Visibilité de la progress bar      
         if ($step.data("progress")=="1") {
             $('.acf-steps .progress-bar').removeClass("hidden");
            } else {
                $('.acf-steps .progress-bar').addClass("hidden");
            }
        }
        catch(e) {
            console.info("error in Kinougarde.formulaireAcf.UpdateProgressBar");
        }
    }

     /**
      * Retour à l'étape précédente
      */
     w.Kinougarde.formulaireAcf.PrevStep = function() {        
        var $button = $(this);
        var  $step = this.CurrentStep();           

        if (!$button.attr('disabled')) {
            var owl = $('.owl-carousel');
            // Modif de la progresse barre
            $step.trigger("form-step-prev-change");
            owl.owlCarousel().trigger('prev.owl.carousel');
            $step.trigger("form-step-prev-changed");            
            //var stepIndex = parseInt($('.acf-steps .progress-bar').attr("data-step"));            
            this.UpdateProgressBar();                                     
        } 
        
     }


     /**
      * Affiche une erreur ajax à l'intérieur de l'étape
      */
     w.Kinougarde.formulaireAcf.AfficherErrorAjax = function(message,messageWrapper=null) {
        var $step = this.CurrentStep();
        var $boutons = $step.find(".acf-steps-form-action");
        // Supprime les erreurs précédentes
        $("div.ajax-error").remove();
        if (messageWrapper==null) {
            $boutons.before('<div class="ajax-error"><div class="notice-error">' + message + '</div></div>');
        } else {
            messageWrapper.html('<div class="ajax-error"><div class="notice-error">' + message + '</div></div>')
        }
        Kinougarde.TagManagerTunnel(null,{event : 'GTMerror', ErrorType: message});
        // Supprime le message d'erreur au bout de 3 secondes
        // setTimeout(function() {
        //     $("div.ajax-error").remove();
        // },3000);
     }


    //  w.onpopstate =function(event) {				
    //     console.debug( "popstate !") ;         
    //     if (event.state!==null) {
    //         console.debug( "-- state : " );
    //         console.debug(event.state);
    //         //self.toggle(self.activeIndex, event.state.activeIndex);
    //         var owl = $('.owl-carousel');                        
    //         owl.owlCarousel().trigger('to.owl.carousel',[event.state.activeIndex,200]);
    //     }
    // }
    


})(window);

